/**
 * Wishlist – attach to existing heart icons. No new UI.
 * - data-wishlist-toggle on clickable element
 * - data-product-gid="gid://shopify/Product/123"
 * - Header counter: element with data-wishlist-count
 * - Page data: script#wishlist-data (JSON array of GIDs), body.login-u = logged in
 */
(function () {
  var SELECTORS = {
    toggle: '[data-wishlist-toggle]',
    count: '[data-wishlist-count]',
    dataScript: '#wishlist-data'
  };

  var ENDPOINT = '/apps/wishlist/toggle';
  var LOGIN_URL = '/account/login';

  function getWishlistGids() {
    var script = document.querySelector(SELECTORS.dataScript);
    if (!script || !script.textContent) return [];
    try {
      var list = JSON.parse(script.textContent);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlistGids(gids) {
    var script = document.querySelector(SELECTORS.dataScript);
    if (script) script.textContent = JSON.stringify(gids);
  }

  function isLoggedIn() {
    return document.body.classList.contains('login-u');
  }

  function getCountEls() {
    return document.querySelectorAll(SELECTORS.count);
  }

  function updateCount(count) {
    getCountEls().forEach(function (el) { el.textContent = count; });
  }

  function getCurrentCount() {
    var el = document.querySelector(SELECTORS.count);
    if (!el) return 0;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function getCheckboxForLabel(labelEl) {
    var forId = labelEl.getAttribute('for');
    return forId ? document.getElementById(forId) : null;
  }

  function setCheckboxChecked(checkbox, checked) {
    if (!checkbox) return;
    checkbox.checked = checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setIconActive(toggleEl, active) {
    var icon = toggleEl.querySelector && toggleEl.querySelector('.heart-icon');
    if (icon) {
      if (active) icon.classList.add('active'); else icon.classList.remove('active');
    }
    var checkbox = getCheckboxForLabel(toggleEl);
    if (checkbox) setCheckboxChecked(checkbox, active);
  }

  function isIconActive(toggleEl) {
    var icon = toggleEl.querySelector && toggleEl.querySelector('.heart-icon');
    return icon ? icon.classList.contains('active') : false;
  }

  function initActiveState() {
    var gids = getWishlistGids();
    if (!gids.length) return;

    document.querySelectorAll(SELECTORS.toggle).forEach(function (labelEl) {
      var gid = labelEl.getAttribute('data-product-gid');
      if (!gid || gids.indexOf(gid) === -1) return;
      var checkbox = getCheckboxForLabel(labelEl);
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var icon = labelEl.querySelector && labelEl.querySelector('.heart-icon');
      if (icon) icon.classList.add('active');
    });
  }

  function toggleWishlist(productGid, toggleEl) {
    var gids = getWishlistGids();
    var idx = gids.indexOf(productGid);
    var isAdd = idx === -1;
    var prevActive = isIconActive(toggleEl);
    var prevGids = gids.slice();
    var prevCount = getCurrentCount();

    if (isAdd) {
      gids.push(productGid);
      setIconActive(toggleEl, true);
      updateCount(prevCount + 1);
    } else {
      gids.splice(idx, 1);
      setIconActive(toggleEl, false);
      updateCount(Math.max(0, prevCount - 1));
    }
    setWishlistGids(gids);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productGid: productGid })
    }).then(function (res) {
      if (!res.ok) throw new Error('Wishlist update failed');
    }).catch(function () {
      setWishlistGids(prevGids);
      setIconActive(toggleEl, prevActive);
      updateCount(prevCount);
    });
  }

  function handleClick(e) {
    var toggle = e.target.closest(SELECTORS.toggle);
    if (!toggle) return;

    var gid = toggle.getAttribute('data-product-gid');
    if (!gid) return;

    e.preventDefault();

    if (!isLoggedIn()) {
      window.location.href = LOGIN_URL;
      return;
    }

    var checkboxId = toggle.getAttribute('for');
    var checkbox = checkboxId ? document.getElementById(checkboxId) : null;
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    toggleWishlist(gid, toggle);
  }

  function init() {
    initActiveState();
    document.body.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
